import { render, staticRenderFns } from "./barraBuscaProdutos.vue?vue&type=template&id=4e8e5214&scoped=true"
import script from "./barraBuscaProdutos.vue?vue&type=script&lang=js"
export * from "./barraBuscaProdutos.vue?vue&type=script&lang=js"
import style0 from "./barraBuscaProdutos.vue?vue&type=style&index=0&id=4e8e5214&prod&lang=css"
import style1 from "./barraBuscaProdutos.vue?vue&type=style&index=1&id=4e8e5214&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8e5214",
  null
  
)

export default component.exports